const SEND_URL = 'https://metrika.mos.ru/hitcounter';
const SEND_URL_PREPROD = 'https://metrika.mos.ru/pprod/hitcounter';
const SEND_URL_CONTOUR = 'https://metrika.sm-soft.ru/hitcounter';

const orgId = 'moslabor';
const formId = '006703';

const HOME_DOMAIN = 'mos.ru';

interface EventType {
  type: string;
  subtype: string;
}

function sendCMAStats({ type, subtype }: EventType): void {
  let sendURL = SEND_URL;

  if (window.location.hostname === 'newmos.mos.ru') {
    sendURL = SEND_URL_PREPROD;
  } else if (
    window.location.hostname === 'localhost' ||
    window.location.hostname.match(/\w+-tech.mos.ru/)
  ) {
    sendURL = SEND_URL_CONTOUR;
  }

  const eventObject = {
    timestamp: Math.floor(Date.now() / 1000),
    group: `${orgId}_${formId}`,
    type,
    subtype,
    origin: {
      url: window.location.href,
      org_id: orgId,
      form_id: formId,
      code: 'mos',
    },
  };

  const body = 'payload=' + encodeURIComponent(JSON.stringify(eventObject));

  const getFetchConfig = (): RequestInit => {
    const isHomeService = sendURL.includes(HOME_DOMAIN);
    return isHomeService ? { credentials: 'include' } : {};
  };

  fetch(sendURL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body,
    ...getFetchConfig(),
  }).then();
}

export function sendCMAFormStart(): void {
  sendCMAStats({
    type: 'formcontroller',
    subtype: 'start',
  });
}

export function sendCMAFormStepChange(): void {
  sendCMAStats({
    type: 'step',
    subtype: 'change',
  });
}

export function sendCMAFormSubmit(): void {
  sendCMAStats({
    type: 'step',
    subtype: 'final',
  });
}

export function sendCMATechError(stage: string): void {
  sendCMAStats({
    type: stage,
    subtype: 'error_tech',
  });
}

export function sendCMABusinessError(stage: string): void {
  sendCMAStats({
    type: stage,
    subtype: 'error_biz',
  });
}
